import axios from "axios";
import { baseUrl } from "./baseUrl";

const SERVER_TIME_KEY = "visitor_server_time_offset_ms";
let cachedOffsetMs = null;

export const getServerTimeOffsetMs = () => {
  if (cachedOffsetMs !== null) {
    return cachedOffsetMs;
  }

  try {
    const stored = localStorage.getItem(SERVER_TIME_KEY);
    if (stored !== null && stored !== "") {
      cachedOffsetMs = Number(stored) || 0;
      return cachedOffsetMs;
    }
  } catch (error) {
    // ignore storage errors
  }

  return 0;
};

export const getServerDate = () => {
  const offsetMs = getServerTimeOffsetMs();
  return new Date(Date.now() + offsetMs);
};

export const syncServerTimeOffset = async () => {
  try {
    const response = await axios.get(`${baseUrl}/server-time`);
    const serverUnix = Number(response?.data?.data?.unix);
    if (!Number.isFinite(serverUnix)) {
      return 0;
    }

    const serverMs = serverUnix * 1000;
    cachedOffsetMs = serverMs - Date.now();

    try {
      localStorage.setItem(SERVER_TIME_KEY, String(cachedOffsetMs));
    } catch (error) {
      // ignore storage errors
    }

    return cachedOffsetMs;
  } catch (error) {
    return getServerTimeOffsetMs();
  }
};
